import React from 'react';
import PropTypes from 'prop-types';
import TextField from '../../../../form/TextField';
import { handleBlurEvent } from '../../utilities/utilities';

export const LastNameInputComponent = React.forwardRef(({
  value,
  onChange,
  error,
  errorMessage,
}, ref) => (
  <TextField
    id='in-page-lead-form-last-name-input'
    label='Last name'
    ref={ref}
    name='lastName'
    value={value}
    error={error}
    errorMessage={errorMessage}
    onChange={onChange}
    onBlur={handleBlurEvent}
    required={true}
    customTheme={'leads'}
    maxLength={100} />
));

LastNameInputComponent.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
};

export default LastNameInputComponent;
